export function ApiUnavailable() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="max-w-sm w-full mx-auto p-6 text-center">
        <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
          <span className="text-red-600 text-2xl">!</span>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Serviço indisponível</h2>
        <p className="text-gray-600 text-sm">
          Nossa API está temporariamente fora do ar. Tente novamente em alguns instantes.
        </p>
      </div>
    </div>
  );
}


